import { render, staticRenderFns } from "./PieChartCard.vue?vue&type=template&id=4ac8a5f6"
import script from "./PieChartCard.vue?vue&type=script&lang=js"
export * from "./PieChartCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports